<template>
  <div class="min-h-full flex">
    <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
      <div class="mx-auto w-full max-w-sm lg:w-96">
        <div>
          <img class="h-12 w-auto" src="/images/studio.svg" alt="St. Audio" />
          <h2 class="mt-6 text-3xl font-extrabold text-gray-900">
            Anmelde-Bestätigung ausstehend
          </h2>
        </div>
        <div v-if="message" class="mt-8 bg-red-50 border-l-4 border-red-400 p-4">
          <p class="text-sm text-red-800" v-html="message" />
        </div>
        <div class="mt-4">
          <p class="mt-4">
            Deine kostenlose Studio-Registrierung wurde bisher noch nicht verifiziert. Bitte schaue dafür in dein Postfach nach der Bestätigungs-E-Mail von St. Audio.
          </p>
          <p class="mt-4">
            Du hast keine E-Mail erhalten? Dann kannst du über den folgenden Button einen neuen Link anfordern.
          </p>
        </div>
        <div>
          <div class="mt-6">
            <div class="space-y-6">
              <div v-if="resent">
                <button class="button-success" :disabled="true">
                  Neue E-Mail versendet
                </button>
              </div>
              <div v-else="resent">
                <button @click="onResend" class="button-submit w-full">
                  Neue E-Mail anfordern
                </button>
              </div>
            </div>
            <div class="mt-2">
              <button @click="onLogout" class="button-logout">
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden lg:block relative w-0 flex-1">
      <img class="absolute inset-0 h-full w-full object-cover" src="/images/setup-3.png" alt="" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();

const message = ref('');
const errors = ref({});
const resent = ref(false);

const redirect = () => router.push({ name: "login" });
const success = () => resent.value = true;

const failure = (error) =>
{
  errors.value = (error?.errors) ?? new Object;
  message.value = (error?.message) ?? new String;
};

const onResend = () =>
{
  store.dispatch('auth/resend')
  .then(success)
  .catch(failure);
};

const onLogout = () =>
{
  store.dispatch('auth/logout')
  .then(redirect)
  .catch(redirect);
};
</script>

<style scoped>
.button-logout
{
  @apply w-full flex justify-center py-2 px-4;
  @apply border border-transparent rounded-md shadow-sm;
  @apply text-sm font-medium text-white;
  @apply bg-teal-500 hover:bg-teal-500;
  @apply focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500;
}

.button-success
{
  @apply w-full flex justify-center py-2 px-4;
  @apply border border-transparent rounded-md shadow-sm;
  @apply text-sm font-medium text-white;
  @apply bg-green-700 hover:bg-green-700;
  @apply focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500;
}
</style>
